/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';
import { formatMedicaoPeriodLabel, UNIDADE_LABELS } from './constants';
import MetaPessoalPicker from './MetaPessoalPicker';

const PeriodoSectionHeader = ({
  inicio,
  fim,
  lente,
  metaDiaria,
  alvoDiario,
  onAlvoChange,
  canEditAlvo,
  loading,
}) => {
  const periodoLabel = formatMedicaoPeriodLabel(inicio, fim);
  const unitLabel = UNIDADE_LABELS[lente?.unidade] ?? 'serviços';

  return (
    <Stack spacing={1}>
      <Typography
        variant="overline"
        color="text.secondary"
        sx={{ letterSpacing: 1, display: 'block' }}
      >
        Meu período
      </Typography>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        alignItems={{ xs: 'flex-start', sm: 'baseline' }}
        flexWrap="wrap"
        useFlexGap
      >
        {periodoLabel && (
          <Typography variant="body2">
            Ciclo {periodoLabel}
          </Typography>
        )}
        {lente?.label && (
          <Typography variant="caption" color="text.secondary">
            {lente.label}
          </Typography>
        )}
      </Stack>
      {canEditAlvo && onAlvoChange && (
        <MetaPessoalPicker
          lenteId={lente?.id}
          metaDiaria={metaDiaria}
          alvoDiario={alvoDiario}
          onChange={onAlvoChange}
          disabled={loading}
          unitLabel={unitLabel}
        />
      )}
    </Stack>
  );
};

PeriodoSectionHeader.propTypes = {
  inicio: PropTypes.number,
  fim: PropTypes.number,
  lente: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    unidade: PropTypes.string,
    metaDiaria: PropTypes.number,
  }),
  metaDiaria: PropTypes.number,
  alvoDiario: PropTypes.number,
  onAlvoChange: PropTypes.func,
  canEditAlvo: PropTypes.bool,
  loading: PropTypes.bool,
};

PeriodoSectionHeader.defaultProps = {
  inicio: null,
  fim: null,
  lente: null,
  metaDiaria: null,
  alvoDiario: null,
  onAlvoChange: undefined,
  canEditAlvo: false,
  loading: false,
};

export default PeriodoSectionHeader;
